// Wires the quantity-tier buttons (including the optional Subscribe & Save
// tier) to the shared quantity input, the selling_plan hidden input, and the
// add-to-cart button, without adding a discount code. Selecting a tier sets
// the shared quantity input's value (and the selling_plan input, for the
// Subscribe & Save tier) and updates the visible add-to-cart price to the
// tier's discounted total.
//
// Also listens for the theme's variantChange event so tier prices stay in
// sync when the customer switches variant (e.g. a different size). The new
// values are read from the section HTML the theme already re-fetches on
// variant change, so pricing, discount math, and currency formatting all
// come from the same Liquid template rather than being duplicated in JS.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-quantity-tiers]').forEach(function (wrap) {
    var formId = wrap.getAttribute('data-form');
    var qtyInput = document.querySelector('#' + formId + ' input[name="quantity"], #' + formId + ' .product-form__quantity-id, input.quantity__input[form="' + formId + '"]');
    var sellingPlanInput = document.querySelector('#' + formId + ' input[name="selling_plan"]');
    var submitButton = document.querySelector('#' + formId + ' button[name="add"], form#' + formId + ' button[name="add"]');
    var submitSpan = submitButton ? submitButton.querySelector('span') : null;
    var addToCartLabel = submitSpan ? submitSpan.textContent.trim() : 'Add to cart';

    function updateSubmitLabel(button) {
      var priceLabel = button.querySelector('.product__quantity-tier-price');
      if (submitSpan && priceLabel) {
        submitSpan.textContent = addToCartLabel + ' · ' + priceLabel.textContent.trim();
      }
    }

    function selectTier(button) {
      wrap.querySelectorAll('.product__quantity-tier').forEach(function (b) {
        b.classList.remove('product__quantity-tier--selected');
        b.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('product__quantity-tier--selected');
      button.setAttribute('aria-pressed', 'true');

      var qty = parseInt(button.getAttribute('data-tier-qty'), 10) || 1;
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (sellingPlanInput) {
        var sellingPlanId = button.getAttribute('data-selling-plan-id');
        sellingPlanInput.value = sellingPlanId || '';
      }

      updateSubmitLabel(button);
    }

    wrap.querySelectorAll('.product__quantity-tier').forEach(function (button) {
      button.addEventListener('click', function () {
        selectTier(button);
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event.data || !event.data.html) return;

        var updatedWrap = event.data.html.querySelector('[data-quantity-tiers][data-form="' + formId + '"]');
        if (!updatedWrap) return;

        var updatedUnitPrice = updatedWrap.getAttribute('data-unit-price');
        if (updatedUnitPrice !== null) wrap.setAttribute('data-unit-price', updatedUnitPrice);

        var currentButtons = wrap.querySelectorAll('.product__quantity-tier');
        var updatedButtons = updatedWrap.querySelectorAll('.product__quantity-tier');
        if (currentButtons.length !== updatedButtons.length) return;

        var selectedIndex = -1;
        currentButtons.forEach(function (button, index) {
          var updatedButton = updatedButtons[index];
          if (!updatedButton) return;

          if (button.classList.contains('product__quantity-tier--selected')) {
            selectedIndex = index;
          }

          var updatedCents = updatedButton.getAttribute('data-tier-total-cents');
          if (updatedCents !== null) {
            button.setAttribute('data-tier-total-cents', updatedCents);
          }

          var updatedPriceLabel = updatedButton.querySelector('.product__quantity-tier-price');
          var currentPriceLabel = button.querySelector('.product__quantity-tier-price');
          if (updatedPriceLabel && currentPriceLabel) {
            currentPriceLabel.textContent = updatedPriceLabel.textContent;
          }

          var updatedBadge = updatedButton.querySelector('.product__quantity-tier-badge');
          var currentBadge = button.querySelector('.product__quantity-tier-badge');
          if (updatedBadge && currentBadge) {
            currentBadge.textContent = updatedBadge.textContent;
          }
        });

        if (selectedIndex !== -1) {
          updateSubmitLabel(currentButtons[selectedIndex]);
        }
      });
    }
  });
});
